import type { Cascade } from "../types";
export const TILE_SIZE = 32;

export const BOARD_SIZE = 7;

export const BOARD_PIXELS = TILE_SIZE * BOARD_SIZE;

export const SNAP_MS = 120;

export const AUTOMATIC_SLIDE_MS = 140;

export const FLASH_MS = 90;

export const DISSOLVE_MS = 180;

export const FALL_DROP_MS = 150;

export const FALL_SETTLE_MS = 60;

export const FRICTION_SPARK_CAP = 28;

export const FRICTION_SPARK_INTERVAL_MS = 28;

export const FRICTION_SPARK_MIN_SPEED = 0.18;

export const COLORS = ["#c5d0cf", "#927db8", "#6e9b72", "#d0aa50", "#986744", "#7197a1"];

export const TILE_ASSET_IDS = ["sword", "staff", "shield", "key", "wood", "ore"];

export interface CascadeEffectStrength {
  matched: number;
  chain: number;
  boost: number;
}

export function cascadeEffectStrength(cascade: Cascade): CascadeEffectStrength {
  const matched = Math.max(3, new Set(cascade.matched ?? []).size);
  const chain = Math.max(1, cascade.layer || 1);
  const boost = Math.min(1, (matched - 3) * 0.07 + (chain - 1) * 0.16);
  return { matched, chain, boost };
}
